(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('RfidErrorModalController', rfidErrorModalController);

    rfidErrorModalController.$inject = [
        '$scope',
        '$windowInstance',
        'errorMsg',
    ];

    function rfidErrorModalController($scope, $windowInstance, errorMsg) {
        $scope.close = close;
        $scope.errorMsg = errorMsg;

        function close() {
            $windowInstance.close(false);
        }
    }
})();